import { CREATE_ACCOUNT_CALLBACK } from 'config/deepLinking';
import { openInAppBrowser } from 'lib/navigation/openInAppBrowser';

const buildOnboardingUrl = (redirectUrl: string): string => {
  const separator = redirectUrl.includes('?') ? '&' : '?';
  return `${redirectUrl}${separator}redirect_url=${encodeURIComponent(
    CREATE_ACCOUNT_CALLBACK
  )}`;
};

const openOnboardingBrowser = async (redirectUrl: string): Promise<void> => {
  await openInAppBrowser(buildOnboardingUrl(redirectUrl), false, {
    forceCloseOnRedirection: true,
  });
};

export { buildOnboardingUrl, openOnboardingBrowser };
